/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/NineSliceButton',['pixi', 'util/NineSliceWrapper', 'absolute', 'util/eventhandler'],
    function (PIXI, NineSliceWrapper, Absolute, EventHandler) {
        var NineSliceButton = function (downTexture, overTexture, upTexture, width, height,
                                        left, right, top, bottom, label, labelOptions) {
            this.upTexture = new NineSliceWrapper(upTexture, width, height, left, right, top, bottom).generateTexture();
            this.downTexture = new NineSliceWrapper(downTexture, width, height, left, right, top, bottom).generateTexture();
            this.overTexture = new NineSliceWrapper(overTexture, width, height, left, right, top, bottom).generateTexture();
            this.interactive = true;
            this.onClick = new EventHandler();
            PIXI.Sprite.call(this, this.upTexture);
            this.bindListeners();
            if (label && labelOptions) this.initLabel(label, labelOptions);

            this.hasFocus = false;
        };

        NineSliceButton.prototype = Object.create(PIXI.Sprite.prototype);
        NineSliceButton.prototype.constructor = NineSliceButton;

        NineSliceButton.prototype.bindListeners = function () {
            this.interactive = true;
            this.buttonMode = true;

            if (Absolute.Platform.supportsTouch()) {
                this.bindTouchEvents();
                // Support mouse on laptops/desktops that have touch displays
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    this.bindMouseEvents();
                }
            } else {
                this.bindMouseEvents();
            }
        };

        NineSliceButton.prototype.bindTouchEvents = function () {
            this.touchstart = function (evt) {
                this.setTexture(this.downTexture);
            };

            this.touchend = function (evt) {
                this.setTexture(this.upTexture);
                this.handleInputUp();
            };

            this.touchendoutside = function (evt) {
                this.setTexture(this.upTexture);
            };
        };

        NineSliceButton.prototype.bindMouseEvents = function () {
            this.mouseover = function (evt) {
                this.setTexture(this.overTexture);
            };
            this.mouseout = function (evt) {
                this.setTexture(this.upTexture);
            };

            this.mousedown = function (evt) {
                this.setTexture(this.downTexture);
            }.bind(this);

            this.mouseup = function (evt) {
                this.setTexture(this.upTexture);
                this.handleInputUp();
            }.bind(this);
        };

        NineSliceButton.prototype.initLabel = function (label, labelOptions) {
            var labelTextStyle = {
                font: labelOptions.font,
                fontFamily: labelOptions.fontFamily,
                fill: labelOptions.fill,
                align: labelOptions.align ? labelOptions.align : 'left'
            };
            var label = new PIXI.Text(label, labelTextStyle);
            Absolute.StringManager.shrinkToFit(label,
                Absolute.StringManager.extractNumbersFromString(labelOptions.font),
                '', this.width - Absolute.Coords.x(20));
            this.addChild(label);
            if (labelOptions.anchor) {
                label.anchor.set(labelOptions.anchor.x, labelOptions.anchor.y);
            }
            label.position.set(labelOptions.x, labelOptions.y);
        };

        NineSliceButton.prototype.handleInputUp = function () {
            Absolute.AudioManager.playSound('button');
            this.onClick.handleEvent(this);
        };

        NineSliceButton.prototype.handleActivate = function () {
            Absolute.AudioManager.playSound('button');
            this.onClick.handleEvent(this);
        };

        NineSliceButton.prototype._focusChanged = function () {
            if (this.hasFocus) {
                this.setTexture(this.overTexture);
            } else {
                this.setTexture(this.upTexture);
            }
        };

        Object.defineProperty(NineSliceButton.prototype, "focus", {
            get: function () {
                return this.hasFocus;
            },
            set: function (value) {
                this.hasFocus = value;
                this._focusChanged();
                return value;
            }
        });

        return NineSliceButton;
    });

